import { APIController } from '../api/controller';
import { UserModel } from './model';
import { action, autorun, IReactionDisposer, runInAction } from 'mobx';
import { BasketController } from '../basket/controller';
import { AuthController } from '../auth/controller';

export class UserController {
  constructor(
    private model: UserModel,
    private api: APIController,
    private basket: BasketController,
    private auth: AuthController,
  ) {
    this._disposers = [];
    let identity = model.user ? model.user.identity : null;

    this._disposers.push(autorun(() => {
      if (model.user && model.user.identity !== identity) {
        identity = model.user.identity;
        this.getBasketContents();
        this.getYoutubeChannel(model.user.default_channel);
        this.getYoutubeChannels();
        this.getAccounts();
      } else {
        identity = null;
        this.model.loading = false;
        this.model.loadingChannels = false;
      }
    }));
  }

  private _disposers: IReactionDisposer[];

  dispose = () => {
    this._disposers.forEach(dispose => dispose());
  };

  @action
  getYoutubeChannel = async (identity: string) => {
    const { user } = this.model;
    if (!user) return;

    runInAction(() => {
      this.model.loading = true;
    });

    const [channel, channelBrandSponsored] = await Promise.all([
      this.api.user.getYouTubeChannel(user.identity, identity, false),
      this.api.user.getYouTubeChannel(user.identity, identity, true),
    ]);

    runInAction(() => {
      this.model.channel = channel.data;
      this.model.channelBrandSponsored = channelBrandSponsored.data;
      this.model.loading = false;
    });
  };

  @action
  getYoutubeChannels = async () => {
    const { user } = this.model;
    if (!user) return;

    runInAction(() => {
      this.model.loadingChannels = true;
    });

    const channels = await this.api.user.getYouTubeChannels(user.identity);

    runInAction(() => {
      this.model.channels = channels.data;
      this.model.loadingChannels = false;
    });
  };

  @action
  getAccounts = async () => {
    const { user } = this.model;
    if (!user) return;

    runInAction(() => {
      this.model.loadingAccounts = true;
    });

    try {
      const accounts = await this.api.user.getAccounts(user.identity);

      runInAction(() => {
        this.model.accounts = accounts.data;
        this.model.loadingAccounts = false;
      });
    } catch(e) {
      console.log(e);
    } finally {
      runInAction(() => {
        this.model.loadingAccounts = false;
      });
    }
  };

  @action
  getBasketContents = async () => {
    return this.basket.getBasket();
  };

  @action
  unlinkSpotify = async () => {
    this.model.isUnlinking.spotify = true;
    await this.api.user.unlinkSpotify(this.model.user.identity);
    await this.getAccounts();
    this.model.isUnlinking.spotify = false;
  };

  @action
  unlinkTwitter = async () => {
    this.model.isUnlinking.twitter = true;
    await this.api.user.unlinkTwitter(this.model.user.identity);
    await this.getAccounts();
    this.model.isUnlinking.twitter = false;
  };

  @action
  unlinkDropbox = async () => {
    this.model.isUnlinking.dropbox = true;
    await this.api.user.unlinkDropbox(this.model.user.identity);
    await this.getAccounts();
    this.model.isUnlinking.dropbox = false;
  };

  @action
  unlinkFacebook = async () => {
    this.model.isUnlinking.facebook = true;
    await this.api.user.unlinkFacebook(this.model.user.identity);
    await this.getAccounts();
    this.model.isUnlinking.facebook = false;
  };
}